import * as React from 'react';
import styled from 'styled-components';

import { ToolbarProps } from './Toolbar.types';

const Main = styled.div`
  display: flex;
  align-items: center;
  box-sizing: content-box;
  user-select: none;
  min-height: 40px;
  color: rgb(68, 68, 68);
`;

export const ToolbarBase = React.forwardRef<HTMLDivElement, ToolbarProps>(
  ({ className, children }, ref) => {
    return (
      <Main data-testid="Toolbar" className={className} ref={ref}>
        {children}
      </Main>
    );
  }
);

export const Toolbar = React.forwardRef<HTMLDivElement, ToolbarProps>(
  ({ className, ...props }: ToolbarProps, ref) => (
    <ToolbarBase className={className} {...props} ref={ref} />
  )
);
